export const LOYALTY_PROGRAM_CONSTANTS = {
  ROAD_WARRIOR: "/assets/images/less-star.svg",
  JET_SETTER: "/assets/images/more-star-half.svg",
  AMBASSADOR: "/assets/images/full-star-border.svg",
};
